'use client'

import { useEffect } from 'react'

type Props = {
  javascript: string | undefined | null
}

export const RenderInlineScript = ({ javascript }: Props) => {
  useEffect(() => {
    if (javascript) {
      // Generate a unique ID for the script element
      const scriptId = `inline-script-${Math.random().toString(36).substr(2, 9)}`
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = scriptId // Assign the unique ID to the script
      script.text = `try { ${javascript} } catch (error) { console.error(error) }`
      document.body.appendChild(script)

      // Cleanup function to remove the script when component unmounts
      return () => {
        const existingScript = document.getElementById(scriptId)
        if (existingScript) {
          document.body.removeChild(existingScript)
        }
      }
    }
  }, [javascript])

  return null // This component does not render any visible elements
}
